import { Link } from "react-router-dom";
import type { Movie } from "@/types/content";

interface MovieCardProps {
  movie: Movie;
  index?: number;
}

export default function MovieCard({ movie, index = 0 }: MovieCardProps) {
  return (
    <article
      className="group animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <Link
        to={`/detail/${movie.id}`}
        className="block cursor-pointer"
        aria-label={`查看 ${movie.title} 详情`}
      >
        <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg border border-background-800 bg-background-800 transition-colors duration-300 group-hover:border-accent-500/70">
          <img
            src={movie.cover}
            alt={`${movie.title} ${movie.type}海报`}
            title={`${movie.title} 高清在线观看`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/10 to-transparent" />
          <span className="absolute left-2 top-2 rounded-md bg-background-950/75 px-2 py-0.5 text-[11px] font-500 text-secondary-300 backdrop-blur-sm">
            {movie.type}
          </span>
          <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-700 text-background-950">
            <span className="flex h-3 w-3 items-center justify-center">
              <i className="ri-star-fill text-[10px]" aria-hidden="true" />
            </span>
            {movie.rating.toFixed(1)}
          </span>
          <div className="absolute inset-x-2 bottom-2 flex items-center justify-between text-[11px] text-foreground-200">
            <span className="rounded-md bg-background-950/70 px-2 py-0.5 backdrop-blur-sm">
              {movie.region}
            </span>
            <span className="rounded-md bg-background-950/70 px-2 py-0.5 backdrop-blur-sm">
              {movie.year}
            </span>
          </div>
        </div>
        <h3 className="mt-3 line-clamp-1 font-heading text-sm font-600 text-foreground-100 transition-colors group-hover:text-accent-400 md:text-base">
          {movie.title}
        </h3>
        <p className="mt-1 line-clamp-1 text-xs text-foreground-500">
          {movie.genres.join(" · ")}
        </p>
      </Link>
    </article>
  );
}